// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swal2-container.swal2-backdrop-show,
.swal2-container.swal2-noanimation {
  background: rgb(187 187 187) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/InactiveLogout/sweetAlertCustom.css"],"names":[],"mappings":"AAAA;;EAEE,uCAAuC;AACzC","sourcesContent":[".swal2-container.swal2-backdrop-show,\n.swal2-container.swal2-noanimation {\n  background: rgb(187 187 187) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
